import React, { useCallback, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Image, notification, Upload } from "antd";
import ImgCrop from "antd-img-crop";

import { config } from "../../config";
import { getUserDetail } from "../../utils/helper";
import { deleteAssetById } from "../../store/api/assets";
import { ASSET_CATEGORIES } from "../../constants";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const AssetUpload = ({ assets }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const [fileList, setFileList] = useState(
    assets.map((asset) => {
      return {
        uid: asset.id,
        name: `image-${asset.id}`,
        status: "done",
        url: `${config.filesBaseUrl}/${asset.filePath}`,
      };
    })
  );

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = useCallback(
    ({ fileList: newFileList, file }) => {
      if (file.status !== "done") {
        setFileList(newFileList);
      } else {
        const index = newFileList.findIndex((f) => f.uid === file.uid);

        if (index !== -1) {
          const { id, filePath } = file.response;
          newFileList[index] = {
            uid: id,
            name: `image-${id}`,
            status: "done",
            url: `${config.filesBaseUrl}/${filePath}`,
          };

          setFileList(newFileList);
        }
      }
    },
    [setFileList]
  );

  const handleRemove = (item) => {
    deleteAssetById(item.uid)
      .then(({ data }) => {
        notification.success({ message: data.message });
      })
      .catch((error) => {
        notification.error({ message: error.response.data.message });
      });
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );
  return (
    <>
      <ImgCrop rotationSlider aspect={2.2} quality={1}>
        <Upload
          action={`${config.apiBaseUrl}/asset/upload`}
          data={{ category: ASSET_CATEGORIES.HOME_BANNER }}
          accept=".jpeg,.jpg,.png"
          listType="picture-card"
          fileList={fileList}
          onPreview={handlePreview}
          headers={{ Authorization: `Bearer ${getUserDetail()?.accessToken}` }}
          multiple={true}
          onChange={handleChange}
          onRemove={handleRemove}
        >
          {fileList.length >= 10 ? null : uploadButton}
        </Upload>
      </ImgCrop>
      {previewImage && (
        <Image
          wrapperStyle={{
            display: "none",
          }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
    </>
  );
};
export default AssetUpload;
